import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { tagsApi } from '@/entities/srm/tag';

import type { TagCreateResponse, TagRequest } from '@/entities/srm/tag';

export const TAGS = 'tags';
export const TAGS_QUERY_KEY = [TAGS, 'list'] as const;

export function useTags() {
  return useQuery({
    queryKey: TAGS_QUERY_KEY,
    queryFn: () => tagsApi.getTagsList().then((res) => res?.data ?? []),

    cacheTime: 120000,
  });
}

type Props = {
  onSuccess?: (data: TagCreateResponse) => void;
};
export function useAddTag(props?: Props) {
  const { onSuccess } = props || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [TAGS, 'create'],
    mutationFn: async (tag: TagRequest) =>
      tagsApi.createTag(tag).then((res) => res?.data),
    onSuccess: (data) => {
      onSuccess?.(data);
      queryClient.invalidateQueries({
        queryKey: TAGS_QUERY_KEY,
        refetchType: 'all',
      });
    },
  });
}